import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["requiredIndicator", "requiredCheckbox"]

  connect() {
    // Initialize the required indicator visibility based on checkbox state
    this.updateRequiredIndicator()
  }

  setupEventListener() {
    if (this.requiredCheckbox) {
      // Remove old listener if it exists
      if (this.checkboxChangeHandler) {
        this.requiredCheckbox.removeEventListener('change', this.checkboxChangeHandler)
      }
      
      // Add new listener
      this.checkboxChangeHandler = () => {
        this.updateRequiredIndicator()
      }
      this.requiredCheckbox.addEventListener('change', this.checkboxChangeHandler)
    }
  }

  setupObserver() {
    // Watch for checkbox to be added to DOM
    const observer = new MutationObserver(() => {
      if (!this.requiredCheckbox) {
        if (this.hasRequiredCheckboxTarget) {
          this.requiredCheckbox = this.requiredCheckboxTarget
        } else {
          this.findCheckbox()
        }
        if (this.requiredCheckbox) {
          this.updateRequiredIndicator()
          this.setupEventListener()
          observer.disconnect()
        }
      }
    })
    
    const container = this.element.closest('.configure-block') || 
                     this.element.closest('form') ||
                     document.body
    observer.observe(container, { childList: true, subtree: true })
    
    // Also try after a delay as fallback
    setTimeout(() => {
      if (!this.requiredCheckbox) {
        if (this.hasRequiredCheckboxTarget) {
          this.requiredCheckbox = this.requiredCheckboxTarget
        } else {
          this.findCheckbox()
        }
        if (this.requiredCheckbox) {
          this.updateRequiredIndicator()
          this.setupEventListener()
        }
        observer.disconnect()
      }
    }, 500)
  }

  findCheckbox() {
    // Search in multiple possible parent containers
    // The checkbox is in a sibling .field.checkbox div
    let container = this.element.closest('.configure-block') ||
                    this.element.closest('form') || 
                    this.element.closest('.step-content-form') ||
                    this.element.parentElement?.parentElement ||
                    this.element.parentElement
    
    if (!container) {
      console.warn('Block configuration controller: No container found')
      return
    }
    
    // Find the has_dependency checkbox - try multiple selectors
    this.requiredCheckbox = container.querySelector('input[name*="[has_dependency]"]') ||
                            container.querySelector('input[name*="has_dependency"]') ||
                            container.querySelector('input[type="checkbox"][data-target*="requiredCheckbox"]') ||
                            container.querySelector('input[id*="has_dependency"]') ||
                            container.querySelector('input[id*="task_block"][id*="has_dependency"]') ||
                            container.querySelector('input[id*="ai_dependency"]')
    
    // If still not found, search in sibling elements
    if (!this.requiredCheckbox) {
      let sibling = this.element.nextElementSibling
      while (sibling) {
        const checkbox = sibling.querySelector('input[type="checkbox"][name*="has_dependency"]')
        if (checkbox) {
          this.requiredCheckbox = checkbox
          break
        }
        sibling = sibling.nextElementSibling
      }
    }
    
    // If still not found, search in the entire document within the same container
    if (!this.requiredCheckbox && container) {
      const allCheckboxes = container.querySelectorAll('input[type="checkbox"]')
      for (let checkbox of allCheckboxes) {
        const name = checkbox.getAttribute('name') || ''
        const id = checkbox.getAttribute('id') || ''
        if (name.includes('has_dependency') || id.includes('has_dependency') || id.includes('dependency')) {
          this.requiredCheckbox = checkbox
          break
        }
      }
    }
  }

  updateRequiredIndicator(event) {
    if (!this.hasRequiredIndicatorTarget) {
      return
    }

    // Get checkbox from event target if available, otherwise use Stimulus target
    let checkbox = null
    if (event && event.target) {
      checkbox = event.target
    } else if (this.hasRequiredCheckboxTarget) {
      checkbox = this.requiredCheckboxTarget
    } else {
      // Fallback: search for checkbox
      this.findCheckbox()
      checkbox = this.requiredCheckbox
    }

    if (!checkbox) {
      return
    }

    const isChecked = checkbox.checked
    
    if (isChecked) {
      this.requiredIndicatorTarget.style.display = 'inline'
    } else {
      this.requiredIndicatorTarget.style.display = 'none'
    }
  }
}

